import React from "react";
import trim from "lodash.trim";
import { Link } from "react-router-dom";
import Capitalize from "lodash.capitalize";

export default ({ url }) => {
  const breadcrumbs = trim(url, "/").split("/");
  return (
    <nav className="breadcrumb is-small" aria-label="breadcrumbs">
      <ul>
        {breadcrumbs.map((breadcrumb, index) => {
          const url = "/" + breadcrumbs.slice(0, index + 1).join("/");
          breadcrumb = index === 0 ? breadcrumb : Capitalize(breadcrumb);

          return (
            <li key={breadcrumb} className={index === breadcrumbs.length - 1 ? `is-active` : ""}>
              <Link to={url}>{breadcrumb}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Breadcrumb.js